import React, { useState } from 'react';

import { EmailCampaignSignupSingleBlockData } from 'api/cms';
import { postJson } from 'utils/http';

import EmailCampaignSignup from './EmailCampaignSignup';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const EmailCampaignSignupSingleBlock = ({
  blockId,
  data: { headline, buttonText, bgImage },
  isSidebar,
}: {
  blockId: string;
  data: EmailCampaignSignupSingleBlockData;
  isSidebar?: boolean;
}) => {
  const [mode, setMode] = useState('initial');

  const onSubmit = ({
    values,
    handleError,
  }: {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: Record<string, any>;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError: (...args: Array<any>) => any;
  }) => {
    const postBaseUrl = isSidebar
      ? '/data/website/sidebar-email-signup-single/'
      : '/data/website/page-email-signup-single/';
    setMode('submitting');
    postJson(postBaseUrl + blockId, values)
      .then(() => {
        setMode('submitted');
      })
      .catch((e) => {
        handleError(e);
        setMode('initial');
      });
  };

  return (
    <EmailCampaignSignup
      disabled={mode === 'submitting'}
      onSubmit={onSubmit}
      headline={headline}
      buttonText={buttonText}
      isSidebar={isSidebar}
      isSubmitted={mode === 'submitted'}
      bgImage={bgImage}
      qaId="cms-email-campaign-signup-single"
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default EmailCampaignSignupSingleBlock;
